import { mediaLifeSpanMVConfig } from '@/lib/analytics/charts/instagram/mediaViewer/mediaLifeSpan';
import { commentsReachMVConfig } from '@/lib/analytics/kpis/instagram/mediaViewer/commentsReach';
import { commentsReceivedMVConfig } from '@/lib/analytics/kpis/instagram/mediaViewer/commentsReceived';
import { engagementRateMVConfig } from '@/lib/analytics/kpis/instagram/mediaViewer/engagementRate';
import { engagementReachMVConfig } from '@/lib/analytics/kpis/instagram/mediaViewer/engagementReach';
import { impressionsViewsMVConfig } from '@/lib/analytics/kpis/instagram/mediaViewer/impressionsViews';
import { impressionViewRateMVConfig } from '@/lib/analytics/kpis/instagram/mediaViewer/impressionViewRate';
import { likesReachMVConfig } from '@/lib/analytics/kpis/instagram/mediaViewer/likesReach';
import { likesReceivedMVConfig } from '@/lib/analytics/kpis/instagram/mediaViewer/likesReceived';
import { reachMVConfig } from '@/lib/analytics/kpis/instagram/mediaViewer/reach';
import { reachRateMVConfig } from '@/lib/analytics/kpis/instagram/mediaViewer/reachRate';
import { reelsAvgTimeWatchedMVConfig } from '@/lib/analytics/kpis/instagram/mediaViewer/reelsAvgTimeWatched';
import { reelsTotalTimeWatchedMVConfig } from '@/lib/analytics/kpis/instagram/mediaViewer/reelsTotalTimeWatched';
import { savesMVConfig } from '@/lib/analytics/kpis/instagram/mediaViewer/saves';
import { savesReachMVConfig } from '@/lib/analytics/kpis/instagram/mediaViewer/savesReach';
import { sharesMVConfig } from '@/lib/analytics/kpis/instagram/mediaViewer/shares';
import { sharesReachMVConfig } from '@/lib/analytics/kpis/instagram/mediaViewer/sharesReach';
import { avgStoriesImpressionsMVConfig } from '@/lib/analytics/kpis/instagram/mediaViewer/stories/avgStoriesImpressions';
import { completedMVConfig } from '@/lib/analytics/kpis/instagram/mediaViewer/stories/completed';
import { exitsMVConfig } from '@/lib/analytics/kpis/instagram/mediaViewer/stories/exits';
import { exitsRateMVConfig } from '@/lib/analytics/kpis/instagram/mediaViewer/stories/exitsRate';
import { repliesMVConfig } from '@/lib/analytics/kpis/instagram/mediaViewer/stories/replies';
import { storiesCompletionRateConfig } from '@/lib/analytics/kpis/instagram/mediaViewer/stories/storiesCompletionRate';
import { storiesReachMVConfig } from '@/lib/analytics/kpis/instagram/mediaViewer/stories/storiesReach';
import { storiesReachRateMVConfig } from '@/lib/analytics/kpis/instagram/mediaViewer/stories/storiesReachRate';
import { tapsBackMVConfig } from '@/lib/analytics/kpis/instagram/mediaViewer/stories/tapsBack';
import { tapsForwardMVConfig } from '@/lib/analytics/kpis/instagram/mediaViewer/stories/tapsForward';
import { totalEngagementsMVConfig } from '@/lib/analytics/kpis/instagram/mediaViewer/totalEngagements';
import { totalInteractionsMVConfig } from '@/lib/analytics/kpis/instagram/mediaViewer/totalInteractions';
import { videoViewsRateMVConfig } from '@/lib/analytics/kpis/instagram/mediaViewer/videoViewsRate';
import { SIZE_50 } from '@/lib/gridElements/size';
import { IG_POST_TYPES, IG_STORY_TYPES, POST, STORY } from '@/lib/posts/postTypes';

export const MediaViewerStatsInstagram = {
    [POST]: {
        [IG_POST_TYPES.TYPE_PHOTO]: [
            { ...totalEngagementsMVConfig, size: SIZE_50 },
            engagementRateMVConfig,
            likesReceivedMVConfig,
            commentsReceivedMVConfig,
            savesMVConfig,
            sharesMVConfig,
            impressionsViewsMVConfig,
            impressionViewRateMVConfig,
            reachMVConfig,
            reachRateMVConfig,
            engagementReachMVConfig,
            likesReachMVConfig,
            commentsReachMVConfig,
            savesReachMVConfig,
            sharesReachMVConfig,
            mediaLifeSpanMVConfig
        ],
        [IG_POST_TYPES.TYPE_VIDEO]: [
            likesReceivedMVConfig,
            videoViewsRateMVConfig,
            commentsReceivedMVConfig,
            engagementRateMVConfig,
            engagementReachMVConfig,
            reachMVConfig,
            reachRateMVConfig,
            impressionsViewsMVConfig,
            savesMVConfig,
            likesReachMVConfig,
            commentsReachMVConfig,
            savesReachMVConfig,
            mediaLifeSpanMVConfig
        ],
        [IG_POST_TYPES.TYPE_CAROUSEL]: [
            { ...totalEngagementsMVConfig, size: SIZE_50 },
            engagementRateMVConfig,
            likesReceivedMVConfig,
            commentsReceivedMVConfig,
            savesMVConfig,
            sharesMVConfig,
            impressionsViewsMVConfig,
            impressionViewRateMVConfig,
            reachMVConfig,
            reachRateMVConfig,
            engagementReachMVConfig,
            likesReachMVConfig,
            commentsReachMVConfig,
            savesReachMVConfig,
            sharesReachMVConfig,
            mediaLifeSpanMVConfig
        ],
        [IG_POST_TYPES.TYPE_REEL]: [
            totalInteractionsMVConfig,
            likesReceivedMVConfig,
            commentsReceivedMVConfig,
            savesMVConfig,
            sharesMVConfig,
            impressionsViewsMVConfig,
            impressionViewRateMVConfig,
            reelsTotalTimeWatchedMVConfig,
            reelsAvgTimeWatchedMVConfig,
            engagementRateMVConfig,
            reachMVConfig,
            { ...engagementReachMVConfig, size: SIZE_50 },
            reachRateMVConfig,
            likesReachMVConfig,
            commentsReachMVConfig,
            savesReachMVConfig,
            sharesReachMVConfig,
            mediaLifeSpanMVConfig
        ]
    },
    [STORY]: {
        [IG_STORY_TYPES.TYPE_PHOTO]: [
            impressionsViewsMVConfig,
            impressionViewRateMVConfig,
            storiesReachMVConfig,
            storiesReachRateMVConfig,
            avgStoriesImpressionsMVConfig,
            completedMVConfig,
            storiesCompletionRateConfig,
            exitsMVConfig,
            exitsRateMVConfig,
            tapsBackMVConfig,
            tapsForwardMVConfig,
            repliesMVConfig
        ],
        [IG_STORY_TYPES.TYPE_VIDEO]: [
            impressionsViewsMVConfig,
            impressionViewRateMVConfig,
            storiesReachMVConfig,
            storiesReachRateMVConfig,
            avgStoriesImpressionsMVConfig,
            completedMVConfig,
            storiesCompletionRateConfig,
            exitsMVConfig,
            exitsRateMVConfig,
            tapsBackMVConfig,
            tapsForwardMVConfig,
            repliesMVConfig
        ]
    }
};
